import { IDecimalRoundBehavior } from "../../../../documaker/domain/format/objects";
import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";

export interface IDecimalRoundBehaviorPropertyEditable {
  decimalRoundBehavior(): IPropertyEditable<IDecimalRoundBehavior>;
}

export function instanceOfIDecimalRoundBehaviorPropertyEditable(instance: any): instance is IDecimalRoundBehaviorPropertyEditable {
  return instance
      && instance.decimalRoundBehavior
      && instanceOfIPropertyEditable<IDecimalRoundBehaviorPropertyEditable>(instance.decimalRoundBehavior());
}
